function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, forwardRef, useEffect } from "react";
import { Container, Table } from "react-bootstrap";
import { Image, Row, Col } from "antd";
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BillCheckList = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$candidates = _ref.candidates,
    candidates = _ref$candidates === void 0 ? [] : _ref$candidates,
    _ref$company = _ref.company,
    company = _ref$company === void 0 ? null : _ref$company,
    _ref$from = _ref.from,
    from = _ref$from === void 0 ? null : _ref$from,
    _ref$to = _ref.to,
    to = _ref$to === void 0 ? null : _ref$to;
  var _useState = useState(candidates),
    _useState2 = _slicedToArray(_useState, 2),
    draftList = _useState2[0],
    setDraftList = _useState2[1];
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    id: "printable",
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              background: "#F3F2EE",
              borderRadius: "5px",
              padding: "13px",
              boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
            },
            children: [/*#__PURE__*/_jsx("h4", {
              children: /*#__PURE__*/_jsx("b", {
                children: company.label
              })
            }), from && to && /*#__PURE__*/_jsxs("b", {
              children: ["P\xE9riode du ", /*#__PURE__*/_jsx(Moment, {
                date: from,
                format: "DD/MM/YYYY"
              }), " au ", /*#__PURE__*/_jsx(Moment, {
                date: to,
                format: "DD/MM/YYYY"
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 20,
            offset: 4
          },
          children: /*#__PURE__*/_jsxs(Table, {
            responsive: true,
            striped: true,
            bordered: true,
            children: [/*#__PURE__*/_jsx("thead", {
              children: /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("th", {
                  children: "Date"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Code Dossier"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Cat\xE9gorie"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Nom"
                }), /*#__PURE__*/_jsx("th", {
                  children: "T\xE9l\xE9phone"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Sign."
                })]
              })
            }), /*#__PURE__*/_jsx("tbody", {
              children: draftList.map(function (c) {
                return /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx(Moment, {
                      date: c.created_at,
                      format: "DD/MM/YYYY"
                    })
                  }), /*#__PURE__*/_jsx("td", {
                    children: c.candidate_code
                  }), /*#__PURE__*/_jsx("td", {
                    children: c.category != "0" && c.category
                  }), /*#__PURE__*/_jsx("td", {
                    children: c.name
                  }), /*#__PURE__*/_jsx("td", {
                    children: c.mobile_first
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx(Image, {
                      src: c.sign_consent,
                      preview: false,
                      width: "45px"
                    })
                  })]
                }, c.id);
              })
            })]
          })
        })
      })]
    })
  });
});
export default BillCheckList;